import { render, staticRenderFns } from "./calendar-edit.vue?vue&type=template&id=1b1ef8b9&"
import script from "./calendar-edit.vue?vue&type=script&lang=js&"
export * from "./calendar-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b1ef8b9')) {
      api.createRecord('1b1ef8b9', component.options)
    } else {
      api.reload('1b1ef8b9', component.options)
    }
    module.hot.accept("./calendar-edit.vue?vue&type=template&id=1b1ef8b9&", function () {
      api.rerender('1b1ef8b9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/calendar-edit.vue"
export default component.exports